/* eslint-disable no-unused-vars */
import { observable, action, makeObservable } from 'mobx';

class Teacher {
    constructor() {
        makeObservable(this);
    }

    @observable createFieldShow = false; //添加
    @action
    setCreateFieldShow = (boolValue) => {
        this.createFieldShow = boolValue;
    };
    @observable editFieldShow = false; //编辑
    @action
    setEditFieldShow = (boolValue) => {
        this.editFieldShow = boolValue;
    };
}
export default new Teacher();
